/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForKubernetesPlatformManaged extends models.StorageConfigurationBaseForKubernetes {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForKubernetesPlatformManaged");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForKubernetesPlatformManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForKubernetesPlatformManaged>): StorageConfigurationForKubernetesPlatformManaged {
        let obj = Object.assign(new StorageConfigurationForKubernetesPlatformManaged(), model);
        StorageConfigurationForKubernetesPlatformManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForKubernetesPlatformManaged>): StorageConfigurationForKubernetesPlatformManaged {
        if (!model) return null;
        return StorageConfigurationForKubernetesPlatformManaged.newInstance(<StorageConfigurationForKubernetesPlatformManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForKubernetesPlatformManaged) {
        if (!obj) return;

        models.StorageConfigurationForKubernetesPlatformManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForKubernetesPlatformManaged): boolean {
        if (models.StorageConfigurationBaseForKubernetes.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForKubernetesPlatformManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
